<template>
    <div id='newNavBarContainer' class="newNavBarContainer">
        <div class="newNavbar">
            <div class="newNavbarBox">
                <el-badge :hidden="messageNumber == 0" :value="messageNumber">
                    <div class="message" @click="openMessageDialog()"></div>
                </el-badge>
                <div class="user_box">
                    <router-link to="/organization">
                        <div style="display: flex; align-items: center">
                            <span class="nick_name">{{ $store.state.userInfor.name }}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                    </router-link>
                    <div class="hidden_box">
                        <div style="display: flex; justify-content: space-between">
                            <div style="display: flex">
                                <router-link to="/organization">
                                    <div class="avatar">
                                        <img :src="$store.state.userInfor.imageUrl" alt="" height="100%"
                                             style="border-radius: 50%"
                                             width="100%"/>
                                    </div>
                                </router-link>
                                <div class="box_right">
                                    <div>
                                        积分：<span style="color: #dd5827"></span>
                                    </div>
                                    <div style="margin-top: 10px">会员</div>
                                </div>
                            </div>
                            <div class="quitLogin" @click.stop="quitLogin()">退出</div>
                        </div>
                    </div>
                </div>
                <div class="lainxi"><span>联系客服</span></div>
            </div>
        </div>
        <div class="navbar">
            <div class="mune">
                <div class="logo"></div>
                <div :class="$store.state.checkedIndex == 0 ? 'mune_item isChecked' : 'mune_item'" @click="arriveAt(0)">
                    <span>首页</span>
                </div>
                <div :class="$store.state.checkedIndex == 1 ? 'inquiry_box isChecked' : 'inquiry_box'">
                    <div>
                        <span>询价</span>
                        <i class="el-icon-arrow-down" style="margin-left: 5px; font-size: 12px;"></i>
                    </div>
                    <i class="el-icon-caret-top dangban"
                       style="color: white; position: absolute;bottom: -3px;left: 50%;"></i>
                    <div class="inquiry_mune" style="    width: 2.9rem;">
                        <div>
                            <div>
                                <span @click="arriveAt(1, 1)">整团询价</span>
                                <b></b>
                                <span @click="arriveAt(1, 2)">项目询价</span>
                                <b></b>
                                <span @click="arriveAt(1, 3)">我的询价</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="$store.state.checkedIndex == 2 ? 'inquiry_box isChecked' : 'inquiry_box'"
                     @click="arriveAt(2)">
                    <div>
                        <span>抢单</span>
                        <i class="el-icon-arrow-down" style="margin-left: 5px; font-size: 12px;"></i>
                    </div>
                    <i class="el-icon-caret-top dangban"
                       style="color: white; position: absolute;bottom: -3px;left: 50%;"></i>
                    <div class="inquiry_mune" style="width: 3.5rem">
                        <div style="display: flex;">
                            <span style="flex: 1;text-align: center" @click="arriveAt(2, 1)">抢单池</span>
                            <b></b>
                            <span style="flex: 2;text-align: center" @click="arriveAt(2, 2)">我抢到的整团询单</span>
                            <b></b>
                            <span style="flex: 2;text-align: center" @click="arriveAt(2, 3)">我抢到的单项询单</span>
                        </div>
                    </div>
                </div>
                <div :class="$store.state.checkedIndex == 3 ? 'inquiry_box isChecked' : 'inquiry_box'"
                     @click="arriveAt(3, 2)">
                    <div>
                        <span>方案</span>
                        <i class="el-icon-arrow-down" style="margin-left: 5px; font-size: 12px;"></i>
                    </div>
                    <i class="el-icon-caret-top dangban"
                       style="color: white; position: absolute;bottom: -3px;left: 50%;"></i>
                    <div class="inquiry_mune" style="width: 3.2rem">
                        <div style="display: flex; ">
                            <span @click.stop="arriveAt(3, 1)">创建方案</span>
                            <b style="height: 20px; border-right: 1px solid #ddd"></b>
                            <span @click.stop="arriveAt(3, 2)">我的方案</span>
                            <b style="height: 20px; border-right: 1px solid #ddd"></b>
                            <span @click.stop="arriveAt(3, 3)">方案库</span>
                            <b style="height: 20px; border-right: 1px solid #ddd"></b>
                            <span @click.stop="arriveAt(3, 4)">回收站</span>
                        </div>
                    </div>
                </div>
                <!-- <div :class="$store.state.checkedIndex ==4 ? 'mune_item isChecked' : 'mune_item'" @click="arriveAt(11,4)">
                  <el-popover
                        placement="top-start"
                        title="标题"
                        width="200"
                        trigger="hover">
                         <div>表格形式</div>
                          <div class="line"></div>
                         <div>行程轴形式</div>
                  <div slot="reference">订单</div>
                </el-popover>
                  <span>订单</span>
                </div> -->
                <div :class="$store.state.checkedIndex == 4 ? 'inquiry_box isChecked' : 'inquiry_box'">
                    <div>
                        <span @click="arriveAt(4)">订单</span>
                        <i class="el-icon-arrow-down" style="margin-left: 5px; font-size: 12px;"></i>
                    </div>
                    <i class="el-icon-caret-top dangban"
                       style="color: white; position: absolute;bottom: -3px;left: 50%;"></i>
                    <div class="inquiry_mune" style="width: 2rem">
                        <div style="display: flex; ">
                            <span @click.stop="arriveAt(4, 1)">表格形式</span>
                            <b style="height: 20px; border-right: 1px solid #ddd"></b>
                            <span @click.stop="arriveAt(4, 2)">行程轴形式</span>
                        </div>
                    </div>
                </div>
                <div :class="$store.state.checkedIndex == 5 ? 'mune_item isChecked' : 'mune_item'" @click="arriveAt(5)">
                    <span>钱包</span>
                </div>
                <div :class="$store.state.checkedIndex == 6 ? 'mune_item isChecked' : 'mune_item'" @click="arriveAt(6)">
                    <span>客户</span>
                </div>
                <audio id="bgMusic"></audio>
            </div>
        </div>
        <div class="main-content">
            <router-view ref="childVue"></router-view>
        </div>
        <create-plan ref="createPlan"></create-plan>
        <message-list ref="messageList"></message-list>
    </div>
</template>

<script>
import createPlan from './plan/leftMoudle/dialog/createPlan.vue';
import messageList from './message/messageList.vue';
import Bus from "@/assets/utils/bus";
import Api from '@/components/Api/index.js'

export default {
    components: {createPlan, messageList},
    data() {
        return {
            messageNumber: 0,

        }
    },
    methods: {
        openMessageDialog() {
            this.$refs.messageList.openDialog()
        },
        getMessageNumber() {
            new Api('oauth').getMessageNumber().then(res => {
                console.log('sxxxx', res)
                if (res.status === 200) {
                    this.messageNumber = res.data
                }
            })
        },
        quitLogin() {
            this.$router.push({path: '/',});
        },
        arriveAt(n, index) {
            this.$store.commit('setCheckIndex', n)
            if (n === 0) {
                this.$router.push({name: "loginIndex",});
            } else if (n == 1) {
                if (index == 2) {
                    this.$router.push({name: "productInquiry",});
                } else if (index == 3) {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 2)
                } else {
                    this.$router.push({name: "planInquiry",});
                }
            } else if (n == 2) {
                if (index == 1) {
                    this.$router.push({name: "commonInquiry",});
                } else if (index == 2) {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 0)
                    this.$store.commit("setRightPopupIndexType", 2)
                } else if (index === 3) {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 2)
                    Bus.$emit('toInquiryPage', 4)
                }
            } else if (n == 3) {
                if (index == 1) {
                    this.$refs.createPlan.beforOpen()
                } else if (index == 2) {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 0)
                } else if (index == 3) {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 2)
                } else {
                    this.$router.push({name: "plan"});
                    this.$store.commit("setRightPopupIndex", 3)
                }
            } else if (n == 4) {
                this.$router.push({
                    name: 'myDeal',
                });
                if (index == 1) {
                    this.$router.push({
                        name: 'myDeal',
                    });
                } else if (index == 2) {
                    alert('暂未开发')
                }
            } else if (n == 5) {
                this.$router.push({
                    name: 'institutionalWallet',
                });
            } else if (n == 6) {
                this.$router.push({
                    name: 'clientAnddistribution',
                });
            }
        }
    },
    beforeDestroy() {
        this.$websocket.close();
        //移除监听
        window.removeEventListener("onmessageWS", data)
    },
    mounted() {
        document.getElementById('newNavBarContainer').scrollIntoView()
        this.getMessageNumber()
        this.$websocket.initWebSocket();

        window.addEventListener("onmessageWS", data => {
            this.getMessageNumber()
            this.$notify.info({
                title: '消息',
                message: data.detail?.data?.content || '您有一条新消息'
            });
        })
    }
}
</script>

<style lang="scss" scoped>
.newNavbar {
    font-size: 0.12rem;

    /deep/ .el-badge__content {
        top: 5px !important;
    }

    .newNavbarBox {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: 9.8rem;
        max-width: 12rem;
        height: 30px;
        margin: 0 auto;

        .lainxi {
            margin-left: 10px;
            cursor: pointer;
        }

        .lainxi:hover {
            color: var(--twoNewBarTextHoverColor);
        }

        .message {

            width: 24px;
            height: 24px;
            background: url("../assets/png/message1.png") no-repeat;
            cursor: pointer;
            background-position-y: center;
        }

        .user_box {
            display: flex;
            cursor: pointer;
            align-items: center;
            height: 36px;
            padding: 10px;
            max-width: 90px;
            position: relative;

            .el-icon-arrow-down {
                transform: rotate(0deg);
                transition: 0.3s all ease;
            }

            .hidden_box {
                position: absolute;
                top: 33px;
                left: 0;
                width: 2.2rem;
                background: white;
                display: none;
                box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.15);
                padding: 0.1rem;
                z-index: 10;

                .avatar {
                    width: 0.6rem;
                    height: 0.6rem;
                    margin: 0.1rem;
                    border-radius: 50%;
                }

                .box_right {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    color: #101010;
                }

                .quitLogin {
                    color: #101010;
                }

                .quitLogin:hover {
                    cursor: pointer;
                    color: #dd5827;
                }
            }
        }

        .user_box:hover {
            cursor: pointer;
            background: white;
            color: var(--twoNewBarTextHoverColor);

            .hidden_box {
                display: block;
            }
        }
    }
}

.navbar {
    width: 100%;
    height: 0.5rem;
    background: var(--navberColor);
    display: flex;
    justify-content: center;

    .mune {
        font-size: 0.14rem;
        color: white;
        display: flex;
        align-items: center;

        .logo {
            width: 0.8rem;
            height: 30px;
            background: url("../assets/png/logo2.png") no-repeat;
            background-size: contain;
        }

        .mune_item {
            line-height: 0.5rem;
            padding: 0 0.2rem;
            cursor: pointer;

            .dangban {
                display: none;
            }
        }

        .mune_item:hover {
            background: var(--navberColorHover);

            .inquiry_mune {
                display: block;
            }

            .dangban {
                display: block;
            }
        }

        .isChecked {
            background: var(--navberColorHover) !important;
            color: var(--navbarTextHoverColor) !important;
        }

        .inquiry_box {
            position: relative;
            display: flex;
            cursor: pointer;
            align-items: center;
            height: 0.5rem;
            padding: 0 0.2rem;
            color: var(--navbarTextColor);

            .dangban {
                display: none;
            }

            .inquiry_mune {
                padding: 10px 0;
                color: var(--navbarCheckTextColor);
                position: absolute;
                top: 0.48rem;
                left: -0.4rem;
                background: white;
                border: 1px solid var(--navberColor);
                display: none;
                z-index: 2;

                > div {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                }

                b {
                    height: 20px;
                    border-right: 1px solid #ddd;
                }

                span {
                    cursor: pointer;
                    padding: 0 0.1rem;
                }
            }
        }

        .inquiry_box:hover {
            background: var(--navberColorHover);

            .inquiry_mune {
                display: block;
            }

            .dangban {
                display: block;
            }
        }
    }
}</style>